import createIcon from '../../createIcon';

/**
 * @component @name Man4
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNzQ5OSA3SDEwLjI0OTlDOS4wMzk5IDcgOC4xMDk5IDguMDcgOC4yNjk5IDkuMjZMOS45OTk5IDIySDEzLjk5OTlMMTUuNzI5OSA5LjI2QzE1Ljg4OTkgOC4wNyAxNC45NTk5IDcgMTMuNzQ5OSA3WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTExLjk5OTkgNkMxMy4xMDQ1IDYgMTMuOTk5OSA1LjEwNDU3IDEzLjk5OTkgNEMxMy45OTk5IDIuODk1NDMgMTMuMTA0NSAyIDExLjk5OTkgMkMxMC44OTUzIDIgOS45OTk5IDIuODk1NDMgOS45OTk5IDRDOS45OTk5IDUuMTA0NTcgMTAuODk1MyA2IDExLjk5OTkgNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Man4 = createIcon('Man4', [
  [
    'path',
    {
      d: 'M13.7499 7H10.2499C9.0399 7 8.1099 8.07 8.2699 9.26L9.9999 22H13.9999L15.7299 9.26C15.8899 8.07 14.9599 7 13.7499 7Z',
      key: '1l4l8y',
    },
  ],
  [
    'path',
    {
      d: 'M11.9999 6C13.1045 6 13.9999 5.10457 13.9999 4C13.9999 2.89543 13.1045 2 11.9999 2C10.8953 2 9.9999 2.89543 9.9999 4C9.9999 5.10457 10.8953 6 11.9999 6Z',
      key: '7gz8b8',
    },
  ],
]);

export default Man4;
